import { NotificationBox, NotificationContent } from '@components/_Revamp/NotificationBox'
import React from 'react'

export interface AdvisorMessageBoxProps {
  children: React.ReactNode;
  rowGap?: string;
}

function AdvisorMessageBox({ children, rowGap }: AdvisorMessageBoxProps) {
  return (
    <NotificationBox margin={"24px 0"}>
      <NotificationContent rowGap={rowGap}>
        {children}
      </NotificationContent>
    </NotificationBox>
  )
}

export default AdvisorMessageBox